import { generateEdgesWithBridging } from "../utils/HelperFunctions";

/**
 * This class holds the data for the Trailblazer graph.
 * Given the node data, it will generate the nodes and edges that visualizes the data.
 * All graph operations are performed in this class.
 */
export default class TrailblazerGraphData {
    constructor(initialData) {
        if (!initialData) {
            this.initialNodeData = {
                nodes: [],
                edges: []
            };
        } else {
            this.initialNodeData = initialData;
        }
        this.resetGraphData();
    }

    /**
     * Resets the nodes and edges in graph.
     */
    resetGraphData() {
        this.nodes = this.initialNodeData.nodes;
        this.edges = this.initialNodeData.edges;
    }

    /**
     * Gets all the elements in this graph for the Cytoscape element list
     */
    getElements() {
        return [
            ...this.nodes.map(node => node.toCytoscapeElement()),
            ...this.edges.map(edge => edge.toCytoscapeElement())
        ];
    }

    /**
     * Applies a filter function to the nodes of the graph, updating the nodes and edges to show.
     */
    applyFilter(filterFunction) {
        if (this.nodes.length <= 2) {
            return;
        }

        // Always keep first and last nodes
        const firstNode = this.nodes[0];
        const lastNode = this.nodes[this.nodes.length - 1];

        // Filter intermediate nodes (excluding first and last)
        const intermediateNodes = this.nodes.slice(1, -1);
        const filteredIntermediateNodes = intermediateNodes.filter(filterFunction);

        // Combine first, filtered intermediates, and last
        const filteredNodes = [firstNode, ...filteredIntermediateNodes, lastNode];

        const filteredEdges = generateEdgesWithBridging(filteredNodes);
        this.nodes = filteredNodes;
        this.edges = filteredEdges;
    }
}